import type { HTMLAttributes } from 'react';
import css from './ColumnContainer.module.css';

interface BlogContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
  children?: React.ReactNode;
}

export function ColumnContainer({ children, className, size = 'lg', ...props }: BlogContainerProps) {
  const classes = [css.container, css[size], className].filter(Boolean).join(' ');

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
}
